import {
    Component,
    h,
    Prop,
    ComponentInterface,
    Host,
    Event,
    EventEmitter,
} from "@stencil/core";
import { Cross } from "../icons/cross";

/**
 * @slot - Content is placed inside the tag if provided without a slot name
 */
@Component({
    tag: "uic-tag",
    styleUrl: "tag.scss",
})
export class Tag implements ComponentInterface {
    /**
     * If set to `true`, indicates that the user is able to remove the tag.
     */
    @Prop() clearable = false;

    /**
     * If set to `true`, the user cannot interact with the tag.
     */
    @Prop() disabled = false;

    /**
     * Emitted when the tag should be removed.
     */
    @Event() uicClear: EventEmitter;

    private handleClear(event: KeyboardEvent | Event) {
        if (event instanceof KeyboardEvent && event.key !== "Delete") {
            return;
        }
        if (!this.clearable || this.disabled) {
            return;
        }

        this.uicClear.emit();
    }

    render() {
        return (
            <Host
                tabindex={this.disabled ? -1 : 0}
                onKeydown={(e) => this.handleClear(e)}
                class={{ "uic-tag": true, "uic-tag--disabled": this.disabled }}
            >
                <slot></slot>
                {this.clearable &&
                    Cross({
                        class: "uic-tag__clear",
                        onClick: (e) => this.handleClear(e),
                    })}
            </Host>
        );
    }
}
